import { render, staticRenderFns } from "./GreenButton.vue?vue&type=template&id=4c12d62c"
import script from "./GreenButton.vue?vue&type=script&lang=js"
export * from "./GreenButton.vue?vue&type=script&lang=js"
import style0 from "./GreenButton.vue?vue&type=style&index=0&id=4c12d62c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports